import "./Badge.scss";

import type { ReactNode } from "react";
import React, { FC } from "react";
import { OverlayTrigger, Spinner } from "react-bootstrap";

import { QuestionIcon } from "../icons/QuestionIcon";
import { renderTooltip } from "../StyledTooltip/StyledTooltip";

export interface IBadgeItem {
  icon?: ReactNode;
  text?: string | null;
  subtitle?: string;
  beforeIcon?: ReactNode;
}

export interface BadgeProps {
  variant: "primary" | "info" | "success" | "danger" | "dark";
  size?: "sm" | "lg";
  content: {
    tooltipText?: string;
    value?: string | null;
    title?: string;
    rightItems?: IBadgeItem[];
  };
}

const Badge: React.FC<BadgeProps> = ({ variant, content, size = "large" }) => {
  const { value, title, rightItems, tooltipText } = content;

  return (
    <div data-testid="badge" className={`new-badge-card ${variant} ${size}`}>
      <div className="d-flex flex-column justify-content-center">
        <div className="badge-value" title={value ? value : undefined}>
          {value ? (
            value
          ) : (
            <Spinner
              className="ms-2"
              size="sm"
              animation="border"
              data-testid="value-loader"
            />
          )}
        </div>
        <div className="badge-title">
          <span>{title}</span>
          {tooltipText && (
            <OverlayTrigger
              placement="bottom"
              overlay={renderTooltip(tooltipText)}
            >
              <span className="ms-1 badge-title--question">
                <QuestionIcon size={12} />
              </span>
            </OverlayTrigger>
          )}
        </div>
      </div>
      {rightItems && (
        <div className="badge-content-items">
          {rightItems.map((item, index) => (
            <div key={index} className="badge-content-item">
              {item.beforeIcon && (
                <span className="me-1">{item.beforeIcon}</span>
              )}
              <div className="badge-content-item-text">
                <div className="d-flex align-center gap-2">
                  {item.icon && (
                    <div className="badge-content-item-icon">{item.icon}</div>
                  )}
                  <div className="badge-content-item-text-title">
                    {item.text !== null ? (
                      item.text
                    ) : (
                      <Spinner
                        className="ms-2"
                        size="sm"
                        animation="border"
                        data-testid="right-item-loader"
                      />
                    )}
                  </div>
                </div>
                {item.subtitle && (
                  <div className="badge-content-item-text-subtitle">
                    {item.subtitle}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { Badge };
